import {JigsawPuzzle} from 'react-jigsaw-puzzle/lib';
import CommonAppbar from '../../components/common/CommonAppbar';
import React, {createRef} from 'react';
import styled from '@emotion/styled';
import 'react-jigsaw-puzzle/lib/jigsaw-puzzle.css';
import Card from '@mui/material/Card';
import QAndAFooter from '../../components/QuesAndAns/QAndAFooter';
import CardActions from '@mui/material/CardActions';
import {useScreenshot} from 'use-react-screenshot';
import Divider from '@mui/material/Divider';
import QuestionOptions from '../../components/QuesAndAns/QuestionOptions';
import {POLL_AND_QUIZ_SUBTYPE, QUESTION_TYPES} from '../../constants/appConstants';
import {questionSingle} from '../../mockData/question';

const JigsawPuzzleStyled = styled.div`
    border: 1px solid #606060;
    width: 35rem;
    margin: 0 auto;
    border-radius: 1rem;
    overflow: hidden;
`

function JigsawPuzzleExmaple() {
  const [image, takeScreenShot] = useScreenshot();
  const ref = createRef(null);

  const question = questionSingle()
  question.questionType = QUESTION_TYPES.JIGSAW_PUZZLE
  question.settings.showOptionsOnLoad = true


  return <div>
    <CommonAppbar isMainPage={false} pageHeader={'Jigsaw Example'}/>
    {/*<JigsawPuzzle imageSrc={"https://picsum.photos/400"}*/}
    <Card variant={'outlined'}>

      <JigsawPuzzleStyled>
        <JigsawPuzzle
          imageSrc={'https://cdn.dribbble.com/uploads/601/original/ff7474bc9245e3ac5a25cff4f39b2707.png?1544835635'}
          rows={3}
          columns={3}
          onSolved={() => alert('Solved!')}/>
      </JigsawPuzzleStyled>
      <QuestionOptions options={['correct', 'incorrect']} questionType={QUESTION_TYPES.JIGSAW_PUZZLE}
                       subType={POLL_AND_QUIZ_SUBTYPE.NONE} settings={question.settings} showOnlyResults={false}/>
      <Divider sx={{mb: 1}}/>
      <CardActions disableSpacing>
        <QAndAFooter
          handleSkip={() => {
          }} resultImage={image} screenshotRef={ref}
          showEditOption={false}
          withBoost={true}/>
      </CardActions>

    </Card>
  </div>
}

export default JigsawPuzzleExmaple;